export default __webpack_public_path__ + "locales/az/Webhooks.json?hash=5c69a65ed87e365aefcf16fa768f4eca";